import React from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'
import ContestStatisticsContent from './ContestStatisticsContent'
export default class ContestStatistics extends React.Component {
    
    render() {
        let id = this.props.match.params.id;
        let page = this.props.match.params.page;


        // const urlParams = new URLSearchParams(window.location.search);
        return (
            <div className="wrapper">

                <div className="preloader hide flex-column justify-content-center align-items-center">
                    <img className="animation__shake" src="assets/dist/img/AdminLTELogo.png" alt="AdminLTELogo" height="60" width="60" />
                </div>
                <Navbar />
                <Mainmenu />
                <ContestStatisticsContent id={id} page={page} />
                <Footer /> 

            </div>


        )
    }
}
